import src from "IMAGE";
export default { src, width: 1949, height: 1219, blurWidth: 0, blurHeight: 0};
